import * as requestFromServer from './establecimientoCrud';

import { establecimientoSlice, callTypes } from './establecimientoSlice';

const { actions } = establecimientoSlice;

export const fetchEstablecimientos = queryParams => dispatch => {
    dispatch(actions.starCall({ callType: callTypes.action }));
    return requestFromServer
        .getEstablecimientos(queryParams)
        .then(response => {
            const establecimientos = response.data;
            dispatch(actions.establecimientosFetched({ establecimientos }));
        })
        .catch(error => {
            error.clientMessage = error.response && (error.response.data.mensaje || error.response.data);
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

//Trae los establecimientos para Abanderados (paso4)
export const fetchEstablecimientosAbanderado = queryParams => dispatch => {
    dispatch(actions.starCall({ callType: callTypes.action }));
    return requestFromServer
        .getEstablecimientosPaso4(queryParams)
        .then(response => {
            const establecimientos = response.data;
            dispatch(actions.establecimientosAbanderadoFetched({ establecimientos }));
        })
        .catch(error => {
            error.clientMessage = error.response && (error.response.data.mensaje || error.response.data);
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

//Trae los establecimientos para Estatales (paso4)
export const fetchEstablecimientosEstatales = queryParams => dispatch => {
    dispatch(actions.starCall({ callType: callTypes.action }));
    return requestFromServer
        .getEstablecimientosAnteriorPaso4(queryParams)
        .then(response => {
            const establecimientos = response.data;
            dispatch(actions.establecimientosEstatalesFetched({ establecimientos }));
        })
        .catch(error => {
            error.clientMessage = error.response && (error.response.data.mensaje || error.response.data);
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const fetchHermano = queryParams => dispatch => {
    dispatch(actions.starCall({ callType: callTypes.action }));
    return requestFromServer
        .getPersona(queryParams)
        .then(response => {
            const hermano = response.data;
            console.log("Respuesta del back hermano")
            console.log(response);
            dispatch(actions.hermanoFetched({ hermano }));
        })
        .catch(error => {
            error.clientMessage = error.response && (error.response.data.mensaje || error.response.data);
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};
export const fetchFamiliar = queryParams => dispatch => {
    dispatch(actions.starCall({ callType: callTypes.action }));
    return requestFromServer
        .getPersona(queryParams)
        .then(response => {
            const familiar = response.data;
            console.log("Respuesta del back familiar")
            console.log(response);
            dispatch(actions.familiarFetched({ familiar }));
        })
        .catch(error => {
            error.clientMessage = error.response && (error.response.data.mensaje || error.response.data);
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};


export const stateLimpiar = queryParams => dispatch => {
    dispatch(actions.stateLimpiar());
};